var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.type=='vertical')?_c('VerticalTab',{attrs:{"tabs":_vm.tabs,"icon":_vm.icon}}):_c('HorizontalTab',{attrs:{"tabs":_vm.tabs}})}
var staticRenderFns = []

export { render, staticRenderFns }